interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const go = (target: number) => {
    if (target < 1 || target > totalPages || target === page) return;
    onChange(target);
  };

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => go(page - 1)}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => go(1)}
            className="h-9 w-9 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400"
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => go(p)}
          className={`h-9 w-9 rounded-md border text-sm transition-colors ${
            p === page
              ? "border-primary-600 bg-primary-600 font-semibold text-background-50"
              : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button
            type="button"
            onClick={() => go(totalPages)}
            className="h-9 w-9 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400"
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        onClick={() => go(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}